"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInitialValues = void 0;
var react_1 = require("react");
var swr_hooks_1 = require("@l2p/swr-hooks");
var swr_hooks_2 = require("@l2p/swr-hooks");
var navigation_1 = require("next/navigation");
var useInitialValues = function () {
    var _a;
    var data = (0, swr_hooks_1.useGeo)().data;
    var config = (0, swr_hooks_1.useConfig)();
    var countries = (0, swr_hooks_2.useCountriesOptions)({ applyGeoRestrictions: true });
    var currencies = (0, swr_hooks_1.useGenerateCurrencies)();
    var currentCurrency = (0, swr_hooks_1.useCurrentCurrency)();
    var searchParams = (0, navigation_1.useSearchParams)();
    var promocode = searchParams.get('promocode');
    var currentCountry = (0, react_1.useMemo)(function () {
        return (config === null || config === void 0 ? void 0 : config.signUpCountry)
            ? countries.find(function (country) { return country.value === (config === null || config === void 0 ? void 0 : config.signUpCountry); })
            : countries.find(function (country) { var _a; return country.value === ((_a = data === null || data === void 0 ? void 0 : data.geoData) === null || _a === void 0 ? void 0 : _a.countryCode); });
    }, [countries, (_a = data === null || data === void 0 ? void 0 : data.geoData) === null || _a === void 0 ? void 0 : _a.countryCode, config === null || config === void 0 ? void 0 : config.signUpCountry]);
    return (0, react_1.useMemo)(function () { return ({
        country: currentCountry,
        currency: (config === null || config === void 0 ? void 0 : config.signUpCurrency)
            ? currencies === null || currencies === void 0 ? void 0 : currencies.find(function (currency) { return currency.value === (config === null || config === void 0 ? void 0 : config.signUpCurrency); })
            : (currencies === null || currencies === void 0 ? void 0 : currencies.find(function (currency) { return currency.value === currentCurrency; })) ||
                (currencies === null || currencies === void 0 ? void 0 : currencies[0]),
        acceptTerms: !!(config === null || config === void 0 ? void 0 : config.acceptTermsByDefault),
        promocode: promocode,
    }); }, [
        currentCountry,
        currencies,
        currentCurrency,
        promocode,
        config === null || config === void 0 ? void 0 : config.signUpCurrency,
        config === null || config === void 0 ? void 0 : config.acceptTermsByDefault,
    ]);
};
exports.useInitialValues = useInitialValues;
